import React from "react";
import "./WhatsAppButton.css";

export default function WhatsAppButton() {
  return (
    <div className="whatsapp-button">
      <a
        href="https://api.whatsapp.com/send?phone=15715672664&text=Hello%2C%20%40letihbeauty%20%E2%9C%A8%0A%0AI%20would%20like%20to%20know%20more%20about%20the%20services%20and%20schedule%20an%20appointment!%C2%A0%0A%0AThank%20you!%20🤍
"
        class="float whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          className="whatsapp-icon"
        >
          <g clip-path="url(#clip0_1624_1456)">
            <path
              d="M0.853809 19.7608C0.852871 23.1216 1.73787 26.4031 3.42068 29.2955L0.692871 39.178L10.8854 36.5262C13.7045 38.049 16.8631 38.8469 20.0729 38.8472H20.0813C30.6774 38.8472 39.3029 30.2917 39.3074 19.7759C39.3094 14.6802 37.3113 9.88857 33.681 6.28361C30.0513 2.67896 25.224 0.692755 20.0805 0.69043C9.48318 0.69043 0.85834 9.24547 0.853965 19.7608"
              fill="url(#paint0_linear_1624_1456)"
            />
            <path
              d="M0.167188 19.7544C0.166094 23.2361 1.08281 26.635 2.82562 29.631L0 39.8678L10.558 37.1209C13.467 38.6947 16.7423 39.5245 20.0752 39.5257H20.0837C31.06 39.5257 39.9953 30.6625 40 19.7702C40.0019 14.4915 37.9319 9.5276 34.1719 5.79349C30.4114 2.05984 25.4114 0.00217054 20.0837 0C9.10562 0 0.171563 8.86202 0.167188 19.7544ZM6.45484 29.115L6.06062 28.4941C4.40344 25.8795 3.52875 22.8581 3.53 19.7557C3.53344 10.7022 10.9591 3.33643 20.09 3.33643C24.5119 3.33829 28.6675 5.04868 31.7931 8.15194C34.9186 11.2555 36.6384 15.3811 36.6373 19.769C36.6333 28.8225 29.2075 36.1891 20.0837 36.1891H20.0772C17.1064 36.1876 14.1928 35.396 11.6519 33.9L11.0472 33.5442L4.78188 35.1741L6.45484 29.115Z"
              fill="url(#paint1_linear_1624_1456)"
            />
            <path
              d="M15.1061 11.4959C14.7332 10.6737 14.3409 10.6571 13.9864 10.6427C13.6961 10.6303 13.3642 10.6312 13.0326 10.6312C12.7007 10.6312 12.1615 10.7551 11.7057 11.2489C11.2495 11.7432 9.96387 12.9376 9.96387 15.3669C9.96387 17.7962 11.7471 20.1441 11.9957 20.4739C12.2446 20.803 15.4384 25.9478 20.4965 27.9271C24.7003 29.5719 25.5557 29.2447 26.4681 29.1622C27.3806 29.0801 29.4125 27.9681 29.827 26.8151C30.2418 25.6622 30.2418 24.674 30.1175 24.4675C29.9931 24.2618 29.6612 24.1382 29.1636 23.8914C28.6659 23.6446 26.2192 22.4498 25.7631 22.285C25.3068 22.1204 24.9751 22.0382 24.6432 22.5326C24.3114 23.0263 23.3584 24.1382 23.0679 24.4675C22.7778 24.7976 22.4873 24.8387 21.9898 24.5917C21.4918 24.344 19.8892 23.8232 17.9878 22.1412C16.5084 20.8323 15.5096 19.216 15.2193 18.7216C14.929 18.228 15.1882 17.9604 15.4378 17.7143C15.6614 17.4931 15.9356 17.1378 16.1846 16.8495C16.4328 16.5612 16.5156 16.3554 16.6815 16.0261C16.8476 15.6965 16.7645 15.4081 16.6403 15.1612C16.5156 14.9142 15.5486 12.4722 15.1061 11.4959Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1624_1456"
              x1="1931.42"
              y1="3849.45"
              x2="1931.42"
              y2="0.69043"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1FAF38" />
              <stop offset="1" stop-color="#60D669" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1624_1456"
              x1="2000"
              y1="3986.78"
              x2="2000"
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F9F9F9" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <clipPath id="clip0_1624_1456">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
  );
}
